import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { AI_ASSISTANT_BLUE } from "./constants";

export default function AISendButton({ disabled, loading, onClick }) {
  return (
    <IconButton
      aria-label="Send message"
      onClick={onClick}
      disabled={disabled || loading}
      sx={{
        width: 44,
        height: 44,
        flexShrink: 0,
        color: "#fff",
        bgcolor: AI_ASSISTANT_BLUE,
        boxShadow: "0 8px 20px rgba(0, 97, 254, 0.28)",
        "&:hover": { bgcolor: "#0052d6" },
        "&.Mui-disabled": {
          bgcolor: "rgba(0, 97, 254, 0.35)",
          color: "rgba(255,255,255,0.7)",
        },
      }}
    >
      {loading ? <CircularProgress size={18} color="inherit" /> : <SendRoundedIcon fontSize="small" />}
    </IconButton>
  );
}

AISendButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
